import styled from 'styled-components';
import { rem, em } from 'polished';
import { ParagraphStyle } from 'elements/Paragraph/styled';
import { HeadingStyle } from 'elements/Heading/styled';
import { colors, accessibilityHoverInvert } from 'core/theme';
import { media } from 'core/layout';

export const StyledContent = styled.div`
  h1 {
    ${props => HeadingStyle({level: 2})};
  }
  h2 {
    ${props => HeadingStyle({level: 3})};
  }
  h3 {
    ${props => HeadingStyle({level: 4})};
  }
  h4 {
    ${props => HeadingStyle({level: 5})};
  }
  h5 {
    ${props => HeadingStyle({level: 6})};
  }
  h6 {
    ${props => ParagraphStyle({size: 'medium'})};
  }
  * + h1, * + h2, * + h3, * + h4, * + h5, * + h6 {
    margin-top: 2em;
    margin-bottom: 0.75em;
  }
  h1 + p, h2 + p, h3 + p, h4 + p, h5 + p, h6 + p {
    margin-top: 0 !important;
  }

  p {
    ${props => ParagraphStyle({size: 'medium'})};

    & + ul {
      margin-top: 0.5em !important;
    }

    * + &:not(:empty) {
      margin-top: 1.5em;
    }

    &:empty {
      margin: 0;
    }
  }

  a {
    color: ${colors.primary};
    font-size: 1em !important;
    padding: 0.2em;
    margin: -0.2em;

    &:hover {
      color: ${colors.primaryLight};
    }
    ${accessibilityHoverInvert};

    @media screen {
      &[href^="http"]:after {
        content: '';
        display: inline-block;
        vertical-align: top;
        background-image: url(${require('!!url-loader!core/icons/assets/external.svg')});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: ${em(12)};
        height: ${em(12)};
        margin-left: 0.1em;
        opacity: 0.5;
      }

      &[href*=faili]:after {
        display: none;
      }
    }
  }

  ol,
  ul {
    ${props => ParagraphStyle({size: 'medium'})};
    font-size: ${rem(18)};
    margin-bottom: 1em;
    padding-left: 2em;
    -webkit-padding-start: 2em;

    & > li {
      padding-left: 0.5em;

      & > ul,
      & > ol {
        margin-top: 0.5em !important;
      }
    }

    ${media.tabletSmall`
      font-size: 1rem;
    `};
  }

  .tableWrapper {
    border-radius: 2px;
    /* box-shadow: 0 2px 16px 0 rgba(0,0,0,0.1); */
    margin: 1.5em 0 3em;
    overflow-x: auto;
    width: 100%;
  }

  table {
    border-collapse: collapse;
    color: ${colors.text};
    font-size: ${rem(18)};
    line-height: ${28 / 18};
    min-width: 600px;
    width: 100%;

    th {
      font-weight: 500;
      height: ${em(64, 18)};
    }

    th,
    td {
      padding: ${em(12, 18)};

      &:first-child {
        padding-left: ${em(24, 18)};
      }

      &:last-child {
        padding-right: ${em(24, 18)};
      }

      & > p {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        margin: 0 !important;
      }
    }

    td {
      vertical-align: top;
    }

    tr {
      border-bottom: 1px solid ${colors.hairline};
      height: ${em(48, 18)};
    }

    ${media.tabletSmall`
      font-size: ${rem(16)};
    `};
  }

  .introHeading {
    & > p {
      ${props => ParagraphStyle({size: 'large'})};

      ${media.tabletSmall`
        font-size: ${em(21)};
      `};
    }
  }

  .infoBlock {
    ${props => ParagraphStyle({size: 'medium'})};
    font-weight: 500;
    color: ${colors.text};
    display: flex;
    margin: 2em 0 3em 0 !important;

    & > p {
      display: inline-block;
      font-size: 1em;
      color: inherit;
      margin: 0;
    }

    &:before {
      flex: 0 0 ${em(26)};
      content: '';
      display: inline-block;
      vertical-align: top;
      background-image: url(${require('!!url-loader!core/icons/assets/info.svg')});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: ${em(26)};
      height: ${em(26)};
      margin-right: 0.7em;
    }
  }

  .tableBlock {
    display: flex;
    flex-direction: row;
    color: ${colors.subtleText};
    width: fit-content;
    p:not(:first-child) {
      margin-top: 0.5em;
    }
  }

  .tableBlock .column:first-child {
    padding-right: ${em(26)};
  }

  .highlightBlock {
    border-left: 0.5em solid ${colors.hairline};
    padding: 0.5em 0 0.5em 1em;

    p {
      margin: 0;
    }
  }

  .livecam,
  .ratio-4-3 {
    position: relative;
    padding-top: ${(3/4) * 100}%;

    & > iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/elements/util/RawContent/styled.js